export const emptyTemporaryAccessDetails = {
    id: "",
    grantedTo: "",
    creationDate: "",
    expiry: "",
    days: 0,
    hasBeenAccessed: false
};
